import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import moment from "moment/moment";
import { useHistory } from "react-router-dom";

// Apollo
import { UPDATE_SHOP } from "../../../apollo/shop/mutation";
import { GET_SHOP } from "../../../apollo/shop/Query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_PRESIGN_URL } from "../../../apollo/presignUrl/query";
import { GET_PACKAGE } from "../../../apollo/package/query";

// components
import { CREATE_UPDATE_PERMISSINS, DELETED_PERMISSIONS, INLINE_PERMISSIONS, LINEAR_GRADIENT_BG, S3_URL, SHOP_DATA, USER_KEY } from "../../../const";
import { errorSwal, successDeleteSwal } from "../../../helper/sweetalert";

// Icons
import { IconButton } from "@material-ui/core";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EditIcon from "@mui/icons-material/Edit";
import PhoneIcon from "@mui/icons-material/Phone";

// bootrap
import { Modal, Button, Form, Row, Col, Table } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import { useSelector } from "react-redux";
import { checkPermissionHas } from "../../../helper/checkPermissoin";

export default function Profile() {
  const history = useHistory();
  const [imgSrc, setImgSrc] = useState();
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [shopdata, setShopData] = useState();
  const [selectShopdata, setSelectShopdata] = useState();
  const [showupdate, setShowUpdate] = useState();
  const shopdata_id = JSON.parse(localStorage.getItem(SHOP_DATA))?.id;
  const user_data = JSON.parse(localStorage.getItem(USER_KEY))
  const [role, setRole] = useState()

  // reducer
  const { rolePermissions } = useSelector((state) => state.permissions);


  // ==========> useQuery And useMutation <==========
  const [loadShop, { data: shopData, loadingShop }] = useLazyQuery(GET_SHOP, { fetchPolicy: "cache-and-network", });
  const [updateShop, { loading: loadingUpate }] = useMutation(UPDATE_SHOP);
  const [getPresignUrl, { data: presignUrlData }] = useLazyQuery(GET_PRESIGN_URL);

  // ==========> useEffect <==========
  useEffect(() => {
    _fetchShop();
  }, []);

  useEffect(() => {
    if (user_data) {
      setRole(user_data?.data?.role)
    }
  }, [user_data])


  useEffect(() => {
    if (shopData) setShopData(shopData?.shop);
    setImgSrc(S3_URL + shopData?.shop?.image);
  }, [shopData]);

  useEffect(() => {
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  const onHide = () => {
    setShowUpdate(false);
  };

  const _fetchShop = () => {
    const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    loadShop({
      variables: {
        where: {
          id: shopId,
        },
      },
    });
  };


  // <============== Update Shop =================>
  const _updateShop = async (values) => {
    try {
      if (loadingUpate) return;
      await updateShop({
        variables: {
          where: {
            id: shopdata_id,
          },
          data: {
            ...values,
            image: fileName
          },
        },
      });
      successDeleteSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      setShowUpdate(false);
      _fetchShop();
    } catch (err) {
      errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
    }
  };

  // ===============> Image editing <================
  const ImageThumb = ({ image }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          objectFit: "contain",
          borderRadius: 8,
          width: "100%",
        }}
      />
    );
  };

  const handleUpload = async (event) => {
    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;

      const pre = await getPresignUrl({
        variables: {
          name: filename,
        },
      });
      setFileName(filename);
    } catch (error) {
      console.log(error);
    }
  };

  const onFileUpload = async (url) => {
    try {
      if (file && url) {
        const uploadfile = await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
      }
    } catch (error) {
      console.log("ERROR: ", error);
    }
  };

  // Check if the current user has any of the required permissions to edit
  const hasRole = checkPermissionHas(rolePermissions)


  return (
    <div className="user-profile">
      <p className="p-profile" style={{ color: "blue", cursor: "pointer" }} onClick={() => history.goBack()}> ຕັ້ງຄ່າ</p>
      <p className="p-profile">/</p>
      <p className="p-profile">ໂປຣຟາຍ</p>

      <div className="user-profile-container">

        <div className="user-profile-infor">
          <img className="user-profile-img" src={S3_URL + shopData?.shop?.image} />
          <p>{shopData?.shop?.name ?? "-"}</p>
          <p>tell: {shopData?.shop?.phone ?? "-"}</p>
          <p>ເລກລະຫັດວິສາຫະກິດ​: {shopData?.shop?.businessNumber ?? "..."} </p>

          <Button
            hidden={(role === "ADMIN" || hasRole) ? false: true}
            style={{ background: LINEAR_GRADIENT_BG, border: 'none' }}
            onClick={() => { setShowUpdate(true); setSelectShopdata(shopdata); }}
          >
            <EditIcon /> ແກ້ໄຂ
          </Button>
        </div>
        <div className="user-profile-desc">
          <p style={{ opacity: 0.7 }}>ຂໍ້ມູນນຳໃຊ້ລະບົບ</p>
          <p>ຊື່: {user_data?.data?.firstName ?? "-"}</p>
          <p>ນາມສະກຸນ: {user_data?.data?.lastName ?? "-"}</p>
          <p>ເພດ: {user_data?.data?.gender === "MALE" ? "ຊາຍ" : "ຍິງ"}</p>
          <p>ເບີໂທ: {user_data?.data?.phone ?? "-"}</p>
          <p>User name: {user_data?.data?.username ?? "-"}</p>
          <p>Password: ******</p>

          <p>

            <IconButton style={{ color: "red" }}>
              <LocationOnIcon />
            </IconButton>
            ທີ່ຢູ່:  {shopData?.shop?.address.village},&nbsp;
            {shopData?.shop?.address.district},&nbsp;
            {shopData?.shop?.address.province}.
          </p>

        </div>
      </div>

      <Modal
        show={showupdate}
        onHide={() => setShowUpdate(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="modal-width" closeButton>
          <Modal.Title
            style={{ fontSize: "2rem", width: "100%", textAlign: "center" }}
          >
            ແກ້ໄຂຂໍ້ມູນຮ້ານ
          </Modal.Title>
        </Modal.Header>
        <Formik
          className="modal-width"
          initialValues={{
            name: selectShopdata?.name,
            address: {
              village: selectShopdata?.address?.village,
              district: selectShopdata?.address?.district,
              province: selectShopdata?.address?.province,
            },
            phone: selectShopdata?.phone,
            note: selectShopdata?.note,
          }}
          onSubmit={(values, { setSubmitting }) => {
            _updateShop(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <Modal.Body className="modal-width" style={{ padding: "4em" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "start",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <input
                      type="file"
                      id="file-upload"
                      onChange={handleUpload}
                      hidden
                    />
                    <label htmlFor="file-upload">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "#F9FAFB",
                          height: "150px",
                          width: "150px",
                          border: "3px dashed blue",
                          borderRadius: "5%",
                          cursor: "pointer",
                        }}
                      >
                        {file ? (
                          <ImageThumb image={file} />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                              width: "100%",
                              fontSize: "20px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <img src={imgSrc} style={{ width: "100%" }} />
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
                <Form.Label className="form-label">ຊື່ຮ້ານ</Form.Label>
                <Form.Control
                  className="form-input"
                  type="text"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
                <Form.Group className="mt-2">
                  <Form.Label className="form-label">ເລກລະຫັດວິສາຫະກິດ​</Form.Label>
                  <Form.Control
                    className="form-input"
                    type="text"
                    name="businessNumber"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.businessNumber}
                  />
                </Form.Group>
                <br />
                <Form.Label style={{ marginBottom: "0px" }}>
                  ທີ່ຢູ່ບ້ານ
                </Form.Label>
                <Row>
                  <Col style={{ marginTop: "0px" }}>
                    <Form.Label>ບ້ານ</Form.Label>
                    <Form.Control
                      className="form-input"
                      type="text"
                      name="address.village"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.address.village}
                    />
                  </Col>
                  <Col>
                    <Form.Label>ເມືອງ</Form.Label>
                    <Form.Control
                      className="form-input"
                      type="text"
                      name="address.district"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.address.district}
                    />
                  </Col>
                  <Col>
                    <Form.Label>ແຂວງ</Form.Label>
                    <Form.Control
                      className="form-input"
                      type="text"
                      name="address.province"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.address.province}
                    />
                  </Col>
                </Row>
                <Form.Label>ເບີໂທຕິດຕໍ່</Form.Label>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="phone">
                    {" "}
                    <PhoneIcon />{" "}
                  </InputGroup.Text>

                  <Form.Control
                    className="form-input"
                    type="text"
                    name="phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone}
                  />
                </InputGroup>

                <Form.Group>
                  <Form.Label htmlFor="textAreaExample2">
                    ລາຍລະອຽດເພີ່ມເຕີມ
                  </Form.Label>
                  <Form.Control
                    as="textarea" rows={3}
                    name="note"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.note}
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer className="modal-width">
                <Button
                  style={{
                    backgroundColor: "#ededed",
                    color: "black",
                    border: "none",
                  }}
                  onClick={() => onHide()}
                >
                  ຍົກເລີກ
                </Button>
                <Button onClick={() => handleSubmit()}>ບັນທຶກ</Button>
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>
    </div>
  );
}
